// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__sidebar-heading___12Zgy {
  align-items: center;
  color: var(--_apc-sidebar-text-color, var(--steel4));
  display: flex;
  font-weight: 700;
  list-style-type: none;
  margin-bottom: 10px;
  overflow: hidden;
  padding: 0 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

* + .DefaultTheme__sidebar-heading___12Zgy {
  margin-top: 30px;
}

.DefaultTheme__icon___2S5qi {
  fill: currentColor;
  margin-right: 5px;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/platform-components/SidebarHeading/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB","sourcesContent":[".DefaultTheme__sidebar-heading___12Zgy {\n  align-items: center;\n  color: var(--_apc-sidebar-text-color, var(--steel4));\n  display: flex;\n  font-weight: 700;\n  list-style-type: none;\n  margin-bottom: 10px;\n  overflow: hidden;\n  padding: 0 20px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n* + .DefaultTheme__sidebar-heading___12Zgy {\n  margin-top: 30px;\n}\n\n.DefaultTheme__icon___2S5qi {\n  fill: currentColor;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
